export default __webpack_public_path__ + "static/media/rubik-v12-latin-800.74b01c42.woff2";